<div class="container-fluid" [ngClass]="{'p-0': mobileMode(), 'h-100': mobileMode()}" style="position: relative"
  [style.background-color]="clozeTestStyleModel()?.siteBackground">
  <div class="d-flex justify-content-center" [ngClass]="{'h-100': mobileMode()}">
    <div class="card" [ngClass]="{'container-fluid': mobileMode(), 'p-0': mobileMode()}" style="min-height: 570px;"
      [style.background-color]="clozeTestStyleModel()?.exerciseBackground"
      [ngStyle]="{'border': mobileMode() ? '0px' : '1px solid ' + clozeTestStyleModel()?.frameColor, 'border-radius': mobileMode()? '0px' : '0.25rem', 'width': mobileMode()? '' : '720px'}">
      <!-- mobile exercise header -->
      @if (mobileMode()) {
      <div class="onset-indicator">
        <img style="max-width: 100px;float: right;" [src]="cTestLogo()">
      </div>
      }
      <!-- body-->
      <div class="card-body" [ngClass]="{'card-mobile': mobileMode() }" [style.font-family]="clozeTestStyleModel()?.font"
        [style.font-size]="clozeTestStyleModel()?.fontSize">
        @if (clozeTestStyleModel()?.displayLogo && !mobileMode()) {
        <img class="floating-logo" [src]="cTestLogo()">
        }
        @if (onsetExamDataDto()) {
        <div>
          <h5 class="card-title text-center font-weight-bold">{{ 'ONSET-PORTAL-EXAM.IDAS.WELCOME' | translate }}</h5>
          <h5 class="card-title font-weight-bold mt-4">{{ 'ONSET-PORTAL-EXAM.IDAS.YOUR_DATA' | translate }}</h5>

          <div class="row mt-2">
            @if (onsetExamDataDto()?.salutation === 'MR') {
            <div>
              <div class="col">
                <span>{{ 'ONSET-PORTAL-EXAM.IDAS.TITLE' | translate }}
                  {{ 'ONSET-PORTAL-EXAM.IDAS.MR' | translate }}</span>
              </div>
            </div>
            }
            @if (onsetExamDataDto()?.salutation === 'MS') {
            <div>
              <div class="col">
                <span>{{ 'ONSET-PORTAL-EXAM.IDAS.TITLE' | translate }}
                  {{ 'ONSET-PORTAL-EXAM.IDAS.MS' | translate }}</span>
              </div>
            </div>
            }
            @if (onsetExamDataDto()?.salutation === 'NONE') {
            <div>
              <div class="col">
                <span>{{ 'ONSET-PORTAL-EXAM.IDAS.TITLE' | translate }}</span>
              </div>
            </div>
            }
          </div>

          <div class="row mt-2">
            <div class="col">
              <span>{{ 'ONSET-PORTAL-EXAM.IDAS.FIRSTNAME' | translate }} {{onsetExamDataDto()?.firstName}}</span>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              <span>{{ 'ONSET-PORTAL-EXAM.IDAS.LASTNAME' | translate }} {{onsetExamDataDto()?.lastName}}</span>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              <span>{{ 'ONSET-PORTAL-EXAM.IDAS.DATEOFBIRTH' | translate }}
                {{onsetExamDataDto()?.dateOfBirth | date:'dd.MM.yyyy'}}</span>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              <span>{{ 'ONSET-PORTAL-EXAM.IDAS.EMAIL' | translate }} {{onsetExamDataDto()?.email}}</span>
            </div>
          </div>

          <div class="text-center" style="margin-top: 40px;">
            <button class="btn" style="font-size: smaller;" [style.background-color]="cTestButtonColor()"
              (click)="startOnset()">{{ 'ONSET-PORTAL-EXAM.IDAS.START_ONSET' | translate }}</button>
          </div>
        </div>
        }


        <!-- error view -->
        @if (!onsetExamDataDto() && !isLoading()) {
        <div>
          <h5 class="card-title text-center font-weight-bold">{{ 'ONSET-PORTAL-EXAM.IDAS.NO_DATA' | translate }}</h5>
          <h5 class="card-title text-center font-weight-bold">
            {{ 'ONSET-PORTAL-EXAM.IDAS.CURRENT_USER_NO_DATA' | translate }}</h5>
        </div>
        }

        <!-- loading view -->
        @if (isLoading()) {
        <div>
          <h5 class="card-title text-center font-weight-bold">{{ 'ONSET-PORTAL-EXAM.IDAS.LOADING' | translate }}</h5>
        </div>
        }

      </div>
    </div>
  </div>
</div>
